import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */
export async function getLineas(data) {
  try {
    const response = await axios.post("/ProcesosP/Lineas/Get/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function insertLineas(data) {
  try {
    const response = await axios.post("/ProcesosP/Lineas/Post/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function updateLineas(data) {
  try {
    const response = await axios.put("/ProcesosP/Lineas/Put/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getArbolDecision() {
  try {
    const response = await axios.get("/ParametrosGlobales/getArbolDecisiones");
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getLMemoria() {
  try {
    const response = await axios.get("/ParametrosGlobales/getLMemoria");
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}